exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.media-controls-play .glyphicon {\n    color : black;\n    font-size: 20px;\n    vertical-align: middle;\n    padding-bottom: 4px;\n}\n\n.mobile-media-controls-play .glyphicon {\n    font-size: 32px;\n}\n\n.media-controls-play .glyphicon:hover {\n    color: dimgray;\n    cursor: pointer;\n}", ""]);

